import Layout from "@components/templates/Layout";
import React from "react";
import { Outlet } from "react-router-dom";

const LayoutRoutes: React.FC = () => {
  return (
    <Layout hasAside>
      <Outlet />
    </Layout>
  );
};

export default LayoutRoutes;
